// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"cc4e97da","128":"fb8a3937","338":"015e40db","566":"91f29c81"}[chunkId] + ".chunk.js";
};